
import ChannelAnalysisPage from '@/pages/android-channel/channel-analysis';



// 渠道分析
export const channelAnalysis = {
  path: 'android/channelAnalysis',
  component: ChannelAnalysisPage
}




// WEBPACK FOOTER //
// ./src/router/channel.js